/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  Form, Icon, Popup,
} from 'semantic-ui-react';

import MaskedInput from 'react-text-mask';

import { Label, FormInput, Flex } from './styles';

const MaskedFormField = ({
  field, // { name, value, onChange, onBlur }
  form: { errors, touched },
  ...props
}) => (
  <>
    <Form.Field inline={props.inline}>
      <Flex inline={props.inline}>
        {props.labelText && (
          <Label
            error={_.get(errors, field.name) && _.get(touched, field.name)}
            fontSize={props.labelFontSize}
            weight={props.labelWeight}
            color={props.labelColor}
            inline={props.inline}
          >
            {props.labelText}
            {props.content && <Popup trigger={<Icon name="info circle" />} content={props.content} />}
          </Label>
        )}

        <FormInput
          inline={props.inline}
          error={_.get(errors, field.name) && _.get(touched, field.name)}
          audience={props.audience}
        >
          <MaskedInput
            mask={props.mask}
            placeholder={props.placeholder}
            guide={false}
            {...field}
            onBlur={props.onBlur || field.onBlur}
          />
        </FormInput>
      </Flex>
    </Form.Field>
  </>
);

MaskedFormField.propTypes = {
  inline: PropTypes.bool,
  audience: PropTypes.bool,
  mask: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  content: PropTypes.string,
  labelText: PropTypes.string,
  labelFontSize: PropTypes.string,
  labelWeight: PropTypes.string,
  labelColor: PropTypes.string,
  onBlur: PropTypes.func,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
};

MaskedFormField.defaultProps = {
  inline: false,
  audience: false,
  placeholder: '',
  labelText: '',
  content: '',
  labelFontSize: undefined,
  labelColor: undefined,
  labelWeight: undefined,
  onBlur: undefined,
  field: {},
  form: {},
};

export default MaskedFormField;
